import { Children, FC, ReactNode } from 'react';

import { StyledFooter } from './Footer.styles';

export const Footer: FC<{ children?: ReactNode }> = ({ children, ...props }) => {
	if (!children || Children.count(children) === 0) return null;

	return <StyledFooter {...props}>{children}</StyledFooter>;
};
